module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00718.723f5237.jpg";